//NOTE: DO NOT USE THIS this is a static page that was used as a template
// the one that is used in the site is HouseListingGeneric (generic bc all post info gets filled into it)
import React, { useState, useEffect } from "react";
import NavBar from "../../components/NavBar/NavBar";
import styles from "./HouseListing.module.css";
import profilePic from "../../assets/profile.png";
import waterUtilities from "../../assets/waterUtilities.png";
import gasUtilities from "../../assets/gasUtilities.png";
import trashUtilities from "../../assets/trashUtilities.png";
import heaterUtilities from "../../assets/heaterUtilities.png";
import parkingUtilities from "../../assets/parkingUtilities.png";
import laundryUtilities from "../../assets/laundryUtilities.png";
import microwaveUtilities from "../../assets/microwaveUtilities.png";
import ovenUtilities from "../../assets/ovenUtilities.png";
import { Link } from "react-router-dom";


export default function HouseListingPage() {
  return (
    <div className={styles.pageWrap}>
      {/* 🧭 NavBar at top */}
      <NavBar />

      {/* Main listing content */}
      <main className={styles.page}>
        {/* Top card */}
        <section className={styles.card}>
          {/* Left: big house photo */}
          <div className={styles.heroWrap}>
            <img
              className={styles.hero}
              src="https://images.unsplash.com/photo-1507089947368-19c1da9775ae?q=80&w=1200&auto=format&fit=crop"
              alt="House exterior"
            />
          </div>

          {/* Right: details */}
          <div className={styles.details}>
            {/* Price / address / specs */}
            <div className={styles.topline}>
              <h1 className={styles.price}>
                $2,500/month <span className={styles.sub}>($635/room)</span>
              </h1>
              <p className={styles.addr}>138 Main St – Buffalo, NY 14203</p>
              <p className={styles.specs}>4Bedroom • 2Bathroom • 2,215 sqft</p>
            </div>

            {/* Host */}
            <div className={styles.host}>
  <div className={styles.avatarWrap}>
    <img src={profilePic} alt="Profile" className={styles.avatar} />
  </div>
  <div>
    {/* clickable name */}
    <Link to="/profile/matthew" className={styles.hostNameLink}>
      Matthew Hertz
    </Link>
    <div className={styles.hostRole}>Roommate</div>
  </div>
</div>

            {/* Blurb */}
            <p className={styles.blurb}>
              Hey! We’re looking for a 4th roommate to join our cozy home. The house has a
              shared living room and kitchen. It has a basement, backyard and porch. Send us a
              DM if you are interested :).
            </p>

            {/* Amenities */}
            <div className={styles.section}>
  <h2 className={styles.h2}>Amenities/Utilities included:</h2>

  <div className={styles.amenitiesList}>
    <div className={styles.amenItem}>
      <img src={waterUtilities} alt="Water" className={styles.amenIcon} />
      <span>Water</span>
    </div>

    <div className={styles.amenItem}>
      <img src={gasUtilities} alt="Gas" className={styles.amenIcon} />
      <span>Gas</span>
    </div>

    <div className={styles.amenItem}>
      <img src={trashUtilities} alt="Trash removal" className={styles.amenIcon} />
      <span>Trash removal</span>
    </div>

    <div className={styles.amenItem}>
      <img src={heaterUtilities} alt="Heater" className={styles.amenIcon} />
      <span>Heater</span>
    </div>

    <div className={styles.amenItem}>
      <img src={parkingUtilities} alt="Parking" className={styles.amenIcon} />
      <span>Parking</span>
    </div>

    <div className={styles.amenItem}>
      <img src={laundryUtilities} alt="Laundry/dryer" className={styles.amenIcon} />
      <span>Laundry/dryer</span>
    </div>

    <div className={styles.amenItem}>
      <img src={microwaveUtilities} alt="Microwave" className={styles.amenIcon} />
      <span>Microwave</span>
    </div>

    <div className={styles.amenItem}>
      <img src={ovenUtilities} alt="Oven" className={styles.amenIcon} />
      <span>Oven</span>
    </div>
  </div>
</div>
            {/* Tags */}
            <div className={styles.section}>
              <h3 className={styles.h3}>Tags:</h3>
              <div className={styles.tagsWrap}>
                <ul className={styles.tagsCol}>
                  <li>Males</li>
                  <li>Pet Friendly</li>
                  <li>Smoke-Free</li>
                </ul>
                <ul className={styles.tagsCol}>
                  <li>Students</li>
                  <li>Vegetarian</li>
                  <li>Clean</li>
                </ul>
              </div>
            </div>

            {/* People */}
            <div className={styles.section}>
  <div className={styles.titleRow}>
    <h3 className={styles.h3}>People Currently Living:</h3>
    {/* Option A: internal route */}
    <a href="#/profile/placeholder" className={styles.peopleLink}>@placeholder</a>

    {/* Option B (React Router):
    import { Link } from "react-router-dom";
    <Link to="/profile/placeholder" className={styles.peopleLink}>@placeholder</Link>
    */}
  </div>
</div>

            {/* Landlord rating */}
{/* Landlord rating */}
<div className={`${styles.section} ${styles.ratingSection}`}>
  <div className={styles.ratingTitleRow}>
    <h3 className={styles.h3}>Landlord Rating:</h3>
    <StarRating listingId="house-138-main" initial={4} />
  </div>

  <p className={styles.review}>
    Good overall, if something needs to be fixed he will take care of it ASAP.
    However, sometimes he won’t follow the development standards.
  </p>
</div>

          </div>
        </section>
      </main>
    </div>
  );
  function StarRating({ listingId = "demo-listing-1", initial = 4, onChange }) {
  const [rating, setRating] = useState(initial);
  const [hover, setHover] = useState(0);

  // TEMP persistence so it survives refresh (replace with backend later)
  useEffect(() => {
    const saved = localStorage.getItem(`rating:${listingId}`);
    if (saved) setRating(parseInt(saved, 10));
  }, [listingId]);

  useEffect(() => {
    localStorage.setItem(`rating:${listingId}`, String(rating));
    onChange?.(rating);
  }, [rating, listingId, onChange]);

  return (
    <div className={styles.ratingRow} role="radiogroup" aria-label="Rate landlord">
      {[1,2,3,4,5].map((i) => {
        const active = (hover || rating) >= i;
        return (
          <button
            key={i}
            type="button"
            className={`${styles.starBtn} ${active ? styles.starActive : styles.starInactive}`}
            aria-label={`${i} star${i>1?'s':''}`}
            aria-checked={rating === i}
            role="radio"
            onMouseEnter={() => setHover(i)}
            onMouseLeave={() => setHover(0)}
            onFocus={() => setHover(i)}
            onBlur={() => setHover(0)}
            onClick={() => setRating(i)}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}
}
